<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            Paste Links
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_links" data-vv-scope="add_links">
            <v-layout row wrap>
              <v-flex xs12>
                <span>
                  Add links by pasting them in the field below. <i>Domain name</i> is a target domain to be searched for. <i>List of URLs</i> is a list of <i>URLs</i> where the target domain is searched.
                </span>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="from_url"
                  label="Domain name*"
                  v-validate="'required|url'"
                  data-vv-name="add_links.from_url"
                  :error-messages="errors.collect('add_links.from_url')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="target_urls"
                  label="URLs*"
                  hint="Enter URLs one per line"
                  :rules="urlsRules"
                  @input="validUrls = true"
                ></v-textarea>
                {{validUrls}}
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveLinks()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'PasteLinksModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['pasteLinksDialog', 'loading'],
  data () {
    return {
      dialog: this.pasteLinksDialog,
      from_url: '',
      target_urls: '',
      validUrls: true,
      urlsRules: [
        value => !!value || 'Required.',
        value => {
          return this.validUrls || 'Only URL format.'
        }
      ],
      dictionary: {
        en: {
          custom: {
            'add_links.from_url': {
              required: 'Domain required',
              url: 'Only URL format'
            },
            'add_links.target_urls': {
              required: 'Domain required',
              url: 'Only URL format for all rows'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    pasteLinksDialog: {
      handler () {
        this.dialog = this.pasteLinksDialog
        if (this.dialog) {
          this.clearForm()
        }
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('pasteLinksDialog', this.dialog)
      }
    }
  },
  methods: {
    saveLinks () {
      let params = {
        from_url: this.from_url,
        target_urls: this.linksToArray(this.target_urls)
      }

      this.$validator.validateAll('add_links').then(res => {
        if (res && this.$refs.add_links.validate()) {
          this.$parent.$emit('loading', true)

          this.$store.dispatch('PASTE_LINKS', params).then(res => {
            this.$toasted.show('Links were successfully added to project')
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateLinksList')
            this.$store.dispatch('GET_COUNTS')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('PASTE_LINKS ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    linksToArray (strLinks) {
      let arrLinks = []
      const domainPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/ // eslint-disable-line

      // check if there are some lines
      var match = /\r|\n/.exec(strLinks)

      if (match) {
        let arrLines = strLinks.match(/[^\r\n]+/g)
        arrLinks = arrLines.map((line) => {
          return line.trim()
        })
        // join arrays in array
        arrLinks = [].concat.apply([], arrLinks)
      } else {
        arrLinks.push(strLinks.trim())
      }

      // remove empty values
      arrLinks = arrLinks.filter((link) => {
        let notEmpty = link != null && link !== ''
        if (notEmpty && !domainPattern.test(link)) this.validUrls = false
        return notEmpty
      })

      return arrLinks
    },
    closeModal () {
      this.dialog = false
      this.clearForm()
    },
    formToProject () {
      this.project.id = this.projectData.id
      this.project.name = this.form.name
      this.project.domain = this.form.domain
      this.project.subdomains = this.form.subdomains.split(',').map((subdomain) => { return subdomain.trim() }).filter(subdomain => subdomain)
    },
    clearForm () {
      this.from_url = ''
      this.target_urls = ''

      setTimeout(() => {
        this.$validator.errors.clear('add_links')
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/paste-links-modal/PasteLinksModal.vue